var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewEnviroment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 1.99998V3.33331C14.0002 4.57099 13.5085 5.75798 12.6333 6.63315C11.7582 7.50832 10.5712 7.99998 9.3335 7.99998H8.66683V8.66665H12.0002V13.3333C12.0002 13.6869 11.8597 14.0261 11.6096 14.2761C11.3596 14.5262 11.0205 14.6666 10.6668 14.6666H5.3335C4.97987 14.6666 4.64074 14.5262 4.39069 14.2761C4.14064 14.0261 4.00016 13.6869 4.00016 13.3333V8.66665H7.3335V6.66665C7.3335 5.42897 7.82516 4.24199 8.70033 3.36682C9.5755 2.49165 10.7625 1.99998 12.0002 1.99998H14.0002ZM3.66683 1.33331C4.46681 1.33267 5.25524 1.52424 5.96574 1.8919C6.67623 2.25956 7.28798 2.79254 7.7495 3.44598C7.04507 4.3717 6.66464 5.50339 6.66683 6.66665V7.33331H6.3335C5.00741 7.33331 3.73564 6.80653 2.79796 5.86885C1.86028 4.93117 1.3335 3.6594 1.3335 2.33331V1.33331H3.66683Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewEnviroment);
export default __webpack_public_path__ + "static/media/icon--new-enviroment.3bf230492f2caa1ba95e7669fc757752.svg";
export { ForwardRef as ReactComponent };